import React from 'react';
import TimezoneSelect from '../TimezoneSelect';
import { formatDateForInput } from '../scheduleUtils';

export default function DailyWeeklyScheduleFields({
  formData,
  formErrors,
  handleInputChange,
  canEditField,
  isEditing = false,
  setLoading
}) {
  return (
    <div className="row">
      {/* Start Time */}
      <div className="col-md-6">
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label className="pd10botbuilder">
            Start Campaign Time<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="time"
            name="start_time"
            disabled={!canEditField('start_time', isEditing, formData, formData.timezone)}
            data-field="start_time"
            className={`form-control ${formErrors.start_time ? 'is-invalid' : ''}`}
            value={formData.start_time}
            onChange={(e) => handleInputChange('start_time', e.target.value)}
            style={{
              border: formErrors.start_time ? '1px solid #dc3545' : '1px solid #e1e5e9',
              borderRadius: '5px',
              padding: '10px 15px',
              fontSize: '14px'
            }}
          />
          {formErrors.start_time && (
            <div className="error invalid-feedback d-block" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
              {formErrors.start_time}
            </div>
          )}
        </div>
      </div>

      {/* End Time */}
      <div className="col-md-6">
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label className="pd10botbuilder">
            End Campaign Time<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="time"
            name="end_time"
            disabled={!canEditField('end_time', isEditing)}
            data-field="end_time"
            className={`form-control ${formErrors.end_time ? 'is-invalid' : ''}`}
            value={formData.end_time}
            onChange={(e) => handleInputChange('end_time', e.target.value)}
            style={{
              border: formErrors.end_time ? '1px solid #dc3545' : '1px solid #e1e5e9',
              borderRadius: '5px',
              padding: '10px 15px',
              fontSize: '14px'
            }}
          />
          {formErrors.end_time && (
            <div className="error invalid-feedback d-block" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
              {formErrors.end_time}
            </div>
          )}
        </div>
      </div>

      {/* Start Date */}
      <div className="col-md-6">
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label className="pd10botbuilder">
            Start Campaign Date<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="date"
            name="start_date"
            className={`form-control ${formErrors.start_date ? 'is-invalid' : ''}`}
            value={formData.start_date || ''}
            disabled={!canEditField('start_date', isEditing, formData, formData.timezone)}
            min={new Date().toLocaleDateString("en-CA")}
            onKeyDown={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onChange={(e) => handleInputChange('start_date', e.target.value)}
            style={{
              border: formErrors.start_date ? '1px solid #dc3545' : '1px solid #e1e5e9',
              borderRadius: '5px',
              padding: '10px 15px',
              fontSize: '14px'
            }}
          />
          {formErrors.start_date && (
            <div className="error invalid-feedback d-block" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
              {formErrors.start_date}
            </div>
          )}
        </div>
      </div>

      {/* End Date */}
      {/* <div className="col-md-6">
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label className="pd10botbuilder">
            End Date<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="date"
            className="form-control"
            value={formData.end_date}
            min={formData.start_date || new Date().toISOString().split('T')[0]}
            onChange={(e) => handleInputChange('end_date', e.target.value)}
            style={{
              border: '1px solid #e1e5e9',
              borderRadius: '5px',
              padding: '10px 15px',
              fontSize: '14px'
            }}
          />
          <small className="form-text text-muted">
            Leave empty for unlimited schedule_type
          </small>
        </div>
      </div> */}

      {/* Timezone Select */}
      <div className="col-md-6">
        <TimezoneSelect
          value={formData.timezone}
          onChange={(val) => handleInputChange('timezone', val)}
          error={formErrors.timezone}
          disabled={!canEditField('timezone', isEditing, formData, formData.timezone)}
          setLoading={setLoading}
        />
      </div>
    </div>
  );
}
